import React from "react";

const defaultContextValue = {
    index: 0,
    scrollEnabled: true,
    updateContext: (index) => { },
    updateScrollEnabled: (scrollEnabled) => { }
}

const MenuContext = React.createContext(defaultContextValue);

export default MenuContext;